export default __webpack_public_path__ + "static/media/person.0c4b31e7.svg";